import { styled } from '@common/utils/styles'
import { Box, Paper } from '@common/components'

export const Steppper = styled(Paper)(() => ({
  height: '8px',
  width: '100%',
  transition: 'background 0.3s ease-in-out',
}))

export const Flag = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ isSelected }) => ({
  border: isSelected ? '2px solid rgba(0, 97, 253, 0.78)' : 'none',
  '&:hover ': {
    boxShadow: '0px 0px 1px black',
  },
  transition: '.2s',
  cursor: 'pointer',
  width: '60px',
  overflow: 'hidden',
  aspectRatio: '4 / 3',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .fi': {
    width: '100%',
    height: '100%',
    border: '1px solid #e9ecef',
  },
}))
